function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 64.6,
  y: 87.4,
  transform: "matrix(0.7071 0.7071 -0.7071 0.7071 87.4508 -33.3399)",
  width: 38.7,
  height: 3
})));

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 69.5,
  y: 82.5,
  transform: "matrix(0.7071 0.7071 -0.7071 0.7071 85.4222 -38.2372)",
  width: 38.7,
  height: 3
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M50.3,40.9c5,0,9,4,9,9s-4,9-9,9s-9-4-9-9S45.3,40.9,50.3,40.9 M50.3,37.9c-6.6,0-12,5.4-12,12s5.4,12,12,12 c6.6,0,12-5.4,12-12S57,37.9,50.3,37.9L50.3,37.9z"
}))));

var _ref4 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M7.3,88.9c2.2,0,4,1.8,4,4s-1.8,4-4,4s-4-1.8-4-4S5.1,88.9,7.3,88.9 M7.3,85.9c-3.9,0-7,3.1-7,7s3.1,7,7,7s7-3.1,7-7 S11.2,85.9,7.3,85.9L7.3,85.9z"
}))));

var _ref5 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M50.3,18.7c17.2,0,31.3,14,31.3,31.3s-14,31.3-31.3,31.3S19.1,67.2,19.1,50S33.1,18.7,50.3,18.7 M50.3,15.7 c-18.9,0-34.3,15.4-34.3,34.3s15.4,34.3,34.3,34.3S84.6,68.9,84.6,50S69.2,15.7,50.3,15.7L50.3,15.7z"
}))));

var _ref6 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M50.3,28c12.1,0,21.9,9.8,21.9,21.9s-9.8,21.9-21.9,21.9S28.4,62.1,28.4,50S38.2,28,50.3,28 M50.3,25 C36.6,25,25.4,36.2,25.4,50s11.2,24.9,24.9,24.9S75.3,63.7,75.3,50S64.1,25,50.3,25L50.3,25z"
}))));

var _ref7 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 17.7,
  y: 69.5,
  transform: "matrix(0.7065 0.7078 -0.7078 0.7065 63.0677 10.2373)",
  width: 3,
  height: 23.4
})));

var _ref8 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 37,
  y: 55,
  transform: "matrix(0.7065 0.7078 -0.7078 0.7065 55.0504 -9.113)",
  width: 3,
  height: 13.7
})));

var _ref9 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 40.6,
  y: 48.7,
  transform: "matrix(0.7071 0.7071 -0.7071 0.7071 50.2144 -20.7936)",
  width: 19.2,
  height: 3
}))));

var _ref10 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 44.5,
  y: 44.9,
  transform: "matrix(0.7071 0.7071 -0.7071 0.7071 48.6279 -24.6234)",
  width: 19.2,
  height: 3
}))));

var _ref11 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 37.9,
  y: 52.6,
  transform: "matrix(0.7071 0.7071 -0.7071 0.7071 51.8063 -16.9633)",
  width: 17,
  height: 3
}))));

var SvgLoopTwo = function SvgLoopTwo(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve"
  }, props), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("line", {
    style: {
      fill: "#EDEDED"
    },
    x1: 70.3,
    y1: 75.2,
    x2: 97.7,
    y2: 102.6
  }))), _ref), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("line", {
    style: {
      fill: "#EDEDED"
    },
    x1: 75.2,
    y1: 70.3,
    x2: 102.6,
    y2: 97.7
  }))), _ref2)), _ref3, _ref4, _ref5, _ref6, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("line", {
    style: {
      fill: "#EDEDED"
    },
    x1: 10.9,
    y1: 89.4,
    x2: 27.5,
    y2: 72.9
  }))), _ref7), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("line", {
    style: {
      fill: "#EDEDED"
    },
    x1: 33.7,
    y1: 66.7,
    x2: 43.4,
    y2: 57
  }))), _ref8)), _ref9, _ref10, _ref11));
};

export default __webpack_public_path__ + "static/media/loop-two.68c9db20.svg";
export { SvgLoopTwo as ReactComponent };